<template>
  <div>

  </div>
</template>

<script>

import {db} from "@/fb/firebase";

export default {
  name: 'Removed',
  data: function () {
    return {
      userEmail: null,
    }
  },
  mounted () {
    const query = this.$router.currentRoute.query;
    db.ref('users/' + query.user).child('settings/devices/')
        .update({[query.device]: null}).then(() => {

      localStorage.removeItem('extID');
      window.open('https://kidsmode.net/removed/', '_self')
    });
  },
}
</script>

<style lang="scss">

</style>
